document.addEventListener('variant:changed', function (evt) {
  
    setTimeout(() => {
      
        var variantInputs = document.querySelectorAll('.variant-picker__input');
  
        if (variantInputs && variantInputs.length > 0) {
  
            variantInputs.forEach((variantInput) => {

                var activeItem = variantInput.querySelector('.variant-picker__option input:checked:not(.disabled)');

                if(!activeItem) {
                    
                    var items = variantInput.querySelectorAll('.variant-picker__option input:not(.disabled)');

                    if(items.length > 0) {
                        items[0].click();
                    }
                }
  
          });
  
        }
        
    }, 500);

    setTimeout(() => {
      
        var variantInputs = document.querySelectorAll('.variant-picker__input');
  
        if (variantInputs && variantInputs.length > 0) {
  
            variantInputs.forEach((variantInput) => {

                var activeItem = variantInput.querySelector('.variant-picker__option input:checked:not(.disabled)');

                if(!activeItem) {
                    
                    var items = variantInput.querySelectorAll('.variant-picker__option input:not(.disabled)');

                    if(items.length > 0) {
                        items[0].click();
                    }
                }
  
          });
  
        }
        
    }, 1000);
  
});